import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';
import { observer } from 'mobx-react';
import dashboardStore from 'store/dashboardStore';
import LineChartWidget from './widget/LineChartWidget';
import { LineChartConfig } from './config/config';
import M from 'messages';

const LineChartSection = observer(({ queryParams }) => {
  const getDiff = () => {
    const { start, end } = queryParams.params.dateRange;
    const diffTimeStamps = new Date(end).getTime() - new Date(start).getTime();
    const diffDays = Math.ceil(diffTimeStamps / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const xAxisLabelFormater = label => {
    const dayDiff = getDiff();
    if (dayDiff > 1) {
      const days = label.split('/');
      return `${days[0]}.${days[1]}`;
    }
    const hours = label.split(',');
    return hours[1];
  };

  return (
    <Grid container spacing={2} sx={{ mt: 3 }}>
      <Grid size={{ xs: 12, md: 12 }}>
        <LineChartWidget
          title={M.get('dashboard.engagementOverTime')}
          tooltip={M.get('dashboard.engagementOverTimeTooltip')}
          data={dashboardStore.engagementOverTime}
          xAxisLabelFormater={xAxisLabelFormater}
          chartKeys={LineChartConfig}
          tipMessage={M.get('dashboard.lineChart.tipMessage')}
          loading={dashboardStore.engagementOverTimeLoading}
        />
      </Grid>
    </Grid>
  );
});

LineChartSection.propTypes = {
  queryParams: PropTypes.object.isRequired,
};

export default LineChartSection;
